import { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Login.css";
import Swal from "sweetalert2";

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const res = await fetch("https://pbhrm.com/api/staff/login/", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: email,
          password: password,
          device_token: "", // pass your device token if needed
        }),
      });

      const data = await res.json();

      if (data.status === 1) {
        // store user info in localStorage if you want
        localStorage.setItem("user", JSON.stringify(data.data.staff));

        Swal.fire({
          icon: "success",
          title: data.message || "Login successful",
        });

        navigate("/Dashboard");
      } else {
        // API returned error
        setError(data.message || "Invalid email or password");
      }
    } catch (err) {
      setError("Something went wrong. Please try again.");
      console.error(err);
    }
  };

  return (
    <div className="login-layout">
      {/* Left side with background image */}
      <div className="login-left">
        <img src="/assets/images/background.png" alt="logo" />
      </div>

      {/* Right side with form */}
      <div className="login-right">
        <div className="pb">
          <img src="/assets/images/logo/pd.png" alt="logo" />
          {/* <h2>Padmavati Brothers</h2> */}
        </div>
        <form className="login-box" onSubmit={handleSubmit}>
          <input
            type="text"
            placeholder="Username"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          {error && <p className="error">{error}</p>}
          <button type="submit">SIGN IN</button>
        </form>
      </div>
    </div>
  );
}

export default Login;
